import { Component } from '@angular/core';

import { BaseComponent } from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-number',
  templateUrl: './number.component.html',
  host: {
    class: 'uex-input-checkbox'
  }
})
export class InputNumberComponent extends BaseComponent<string> {

}
